import POIHikingStateFields from "@/components/POI/POIStateFields/POIHikingStateFields/POIHikingStateFields.vue";
import POIStep from "@/components/POI/POIStep/POIStep.vue";

export default {
  components: { POIHikingStateFields, POIStep },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
